// Class names repeated across the marketing templates and campaigns pages.

export const labelClass = 'block text-sm font-medium text-zinc-900 dark:text-zinc-100';
export const hintClass = 'mt-1 text-xs text-zinc-500 dark:text-zinc-400';
export const cardClass = 'rounded-2xl border border-surface-border bg-surface-raised';
export const mutedText = 'text-zinc-500 dark:text-zinc-400';

// #region chipClass
/** A segmented-control button. */
export const chipClass = (on: boolean): string =>
    `inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-medium transition ${on ? 'bg-zinc-900 text-white dark:bg-white dark:text-zinc-900' : 'text-zinc-600 hover:bg-zinc-100 dark:text-zinc-300 dark:hover:bg-white/10'}`;

/** A small square icon button. */
export const iconButtonClass =
    'inline-flex h-8 w-8 items-center justify-center rounded-md text-zinc-500 hover:bg-zinc-100 hover:text-zinc-900 disabled:pointer-events-none disabled:opacity-30 dark:text-zinc-400 dark:hover:bg-white/10 dark:hover:text-white';
